var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper empty-permissions" }, [
    !_vm.isMobile
      ? _c("div", { staticClass: "auth-wrapper auth-wrapper-left" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "auth-wrapper-rigth" }, [
      _c("div", { staticClass: "auth-wrapper__content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "You have no permissions yet. Wait for the admin to add your privileges."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mt-6 text-center" }, [
          _c(
            "a",
            { attrs: { href: "javascript:" }, on: { click: _vm.signout } },
            [_vm._v("Sign out")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-wrapper__logo logo" }, [
      _c("figure", { staticClass: "figure-logo" }, [
        _c("img", {
          attrs: { src: "/static/logos/logo_dv7.png", alt: "40%", width: "80%" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a8e74dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8e74dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/empty-permissions/empty-permissions.vue
// module id = null
// module chunks = 